import { Flex } from '@chakra-ui/react'
import { FieldContentNode, ScalarContentNode } from '@helo/cms'

import { NumberRenderer } from '../../../datatypes/number/NumberRenderer'
import { CellRendererProps } from '../table.types'

/**
 * Renders an AG Grid cell as a date.
 */
export const NumberCell = ({
  contentNode,
}: CellRendererProps<number | null> & {
  contentNode: FieldContentNode
}) => {
  return (
    <Flex justifyContent="flex-end">
      <NumberRenderer
        contentNode={contentNode.ofType as ScalarContentNode}
        // options={{ ...{ size: 'small' }, ...config.state }}
        // context={config.context}
      ></NumberRenderer>
    </Flex>
  )
}
